import { render, staticRenderFns } from "./Berkas.vue?vue&type=template&id=414c97dc&"
import script from "./Berkas.vue?vue&type=script&lang=js&"
export * from "./Berkas.vue?vue&type=script&lang=js&"
import style0 from "./Berkas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports